import { APP_NAMES, IAppNames } from "src/constants";
import { fromEnv } from "./";

const routePrefix = fromEnv("REACT_APP_ROUTE_PREFIX");

type IPath = {
  finish: string;
  error: string;
  forceClose: string;
  redirectClaimAdmin: string;
};

const statePaths: IPath = {
  finish: `${routePrefix}/!finish`,
  error: `${routePrefix}/!error`,
  forceClose: `${routePrefix}/!force_close`,
  redirectClaimAdmin: `${routePrefix}/!redirect?to=claim-admin`,
};

export const PATH = Object.keys(APP_NAMES).reduce((all, appName) => {
  return {
    ...all,
    [appName]: `${routePrefix}/${APP_NAMES[appName]}`,
  };
}, statePaths) as IPath & IAppNames;
